import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { NgRatingsService } from "../../../ng-shared/ng-components/ng-ratings/ng-ratings.service";
import {
    ITCIMarketplaceListing,
    ITCILike
} from "@tci/common";


@Injectable()
export class NgMarketplaceV2RatingsService {

    private static instance: NgMarketplaceV2RatingsService = null;

    // Storing the state of connector being updated.
    // Avoid updating issues with async and delayed LIKE responses
    public isUpdating = false;
    private updatingAsset: ITCIMarketplaceListing;
    private likes: number;

    static getInstance(ratingsService: NgRatingsService) {
        if (!NgMarketplaceV2RatingsService.instance) {
            NgMarketplaceV2RatingsService.instance = new NgMarketplaceV2RatingsService(ratingsService);
        }
        return NgMarketplaceV2RatingsService.instance;
    }

    constructor(
        private ratingsService: NgRatingsService
        ) {
    }

    getLikesSubject() {
        return this.ratingsService.getLikesSubject();
    }

    getLikeById(connectorId: string) {
        return this.ratingsService.getLikeById(connectorId);
    }

    createLikebyId(isLiked: boolean, asset: ITCIMarketplaceListing, likeData: ITCILike): Observable<{val: boolean; id: string}> {
        this.isUpdating = true;
        this.updatingAsset = asset;

        if (this.updatingAsset && this.updatingAsset.likes) {
            this.likes = this.updatingAsset.likes.likeCount;
        } else {
            this.likes = 0;
        }
        return new Observable(observer => {
            this.ratingsService
            .createLikebyId(this.updatingAsset.id, likeData)
            .subscribe(res => {
                if (res.success) {
                    const updatedLike = res.data.val;

                    if (updatedLike && !isLiked) {
                        this.likes++;
                        this.likesOnCardUpdate();
                    } else if (!updatedLike && isLiked) {
                        this.likes--;
                        this.likesOnCardUpdate();
                    }
                    observer.next({
                        val: res.data.val,
                        id: this.updatingAsset.id
                    });
                    observer.complete();
                    this.isUpdating = false;
                } else {
                    this.handleError(`Failed POST User Likes for the connector ${this.updatingAsset.id}`);
                    this.isUpdating = false;
                    observer.complete();
                }
            }, err => {
                this.handleError(err);
                this.isUpdating = false;
                observer.complete();
            });
        });
    }


    likesOnCardUpdate() {
        this.ratingsService.updateCardLikes({
            likes: this.likes,
            connectorId: this.updatingAsset.id
        });

    }

    handleError(err) {
        console.log("Ratings Error: ", err);
    }

}
